export default __webpack_public_path__ + "static/media/ProgrammerManagement.122ca4cf.png";